import gql from 'graphql-tag';

export default gql`
mutation createTeam($obj: AddTeamInput!) {
  addTeam(object: $obj) {
    team_id
  }
}
`;
